module.exports = __webpack_public_path__ + "static/img/ai1.04e499b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ai1.jpg
// module id = Aaii
// module chunks = 0